import React, { useState, createRef } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined'
import { Card, Tooltip, Typography } from '@mui/material'

import { attributesNames, colorTypes, userRightTypes } from '../../../../constants'
import { DebugView, Logger, LoggerTypes } from '../../../../utils'
import { DialogDelete, AccessControl } from '../../../../components'
import { AttributeLocationDialogUpdate } from '../dialogs'
import '../../style-common-card.scss'

export const AttributeLocationCard = ({
  currentProject,
  currentScenario,
  location,
  actionDispatchUpdate,
  actionDispatchDelete
}) => {
  const { t } = useTranslation()
  const ref = createRef()

  const [openDialogUpdate, setOpenDialogUpdate] = useState(false)
  const [openDialogDelete, setOpenDialogDelete] = useState(false)

  const onDialogUpdateOpen = () => {
    Logger.trace(LoggerTypes.CONTROLLER, 'AttributeLocationCard.onOpenDialog()')
    setOpenDialogUpdate(true)
  }

  const onDialogDeleteOpen = () => {
    Logger.trace(LoggerTypes.CONTROLLER, 'AttributeLocationCard.onOpenDialogDelete()')
    setOpenDialogDelete(true)
  }

  Logger.trace(LoggerTypes.CONTAINER, 'AttributeLocationCard.render()', { currentProject, currentScenario, location })

  return (
    currentProject && (
      <Card className="common-card">
        <div className="common-card-header">
          <Typography className="common-card-header-name" variant="subtitle2" color={colorTypes.PRIMARY}>
            {location.name}
          </Typography>
          <div className="common-card-header-icon">
            {/* -- Button EDIT -- */}
            <AccessControl userPermissions={[userRightTypes.PROJECT_ATTRIBUTES_EDIT]} renderNoAccess={() => <></>}>
              {actionDispatchUpdate && (
                <Tooltip ref={ref} title={t('common.update')}>
                  <ModeEditOutlineOutlinedIcon
                    onClick={onDialogUpdateOpen}
                    color={colorTypes.PRIMARY}
                    className="buttons-edit-icon"
                  />
                </Tooltip>
              )}
            </AccessControl>

            {/* -- Button DELETE -- */}
            <AccessControl userPermissions={[userRightTypes.PROJECT_ATTRIBUTES_DELETE]} renderNoAccess={() => <></>}>
              {actionDispatchDelete && (
                <Tooltip ref={ref} title={t('common.delete')}>
                  <DeleteOutlineIcon
                    onClick={onDialogDeleteOpen}
                    color={colorTypes.PRIMARY}
                    className="buttons-edit-icon"
                  />
                </Tooltip>
              )}
            </AccessControl>

            {openDialogUpdate && (
              <AttributeLocationDialogUpdate
                currentProject={currentProject}
                currentScenario={currentScenario}
                actionUpdateDispatch={actionDispatchUpdate}
                openDialog={openDialogUpdate}
                setOpenDialog={setOpenDialogUpdate}
                location={location}
              />
            )}
            {openDialogDelete && (
              <DialogDelete
                title={t('attributes.locations.delete.title')}
                message={t('attributes.locations.delete.description')}
                projectId={currentProject?.id}
                scenarioId={currentScenario?.id}
                actionDispatchDelete={actionDispatchDelete}
                openDialog={openDialogDelete}
                setOpenDialog={setOpenDialogDelete}
                variable={location}
              />
            )}
          </div>
        </div>
        <Typography variant="subtitle2" color="secondary">
          {location.description}
        </Typography>
        <div className="common-card-list"></div>
        <DebugView type={attributesNames.LOCATIONS}>{location}</DebugView>
      </Card>
    )
  )
}

AttributeLocationCard.displayName = 'AttributeLocationCard'

AttributeLocationCard.propTypes = {
  location: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number
  }).isRequired,
  currentProject: PropTypes.object,
  currentScenario: PropTypes.object,
  actionDispatchUpdate: PropTypes.func,
  actionDispatchDelete: PropTypes.func
}

AttributeLocationCard.defaultProps = {
  location: null,
  currentProject: null,
  currentScenario: null,
  actionDispatchUpdate: null,
  actionDispatchDelete: null
}
